// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5eb83859","885":"9e60b6ad","977":"6c1c0126"}[chunkId] + ".chunk.js";
};